import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import textRepository from '../repositories/text_repository';
import type { Text } from '../api/TextApi';

export const useTextStore = defineStore('texts', () => {
    

     const texts = ref<Text[]>([]);
    const isLoading = ref( true);
   
    // Methods
    const fetchTexts = async () => {
        try {
           const response = await textRepository.texts.textsList({ appId: 'travel' });
            texts.value = response.data ?? [];
        } catch (error) {
            console.error('Error fetching text:', error);
            // Don't throw error to allow fallback text to work
        } finally {     
            isLoading.value = false;
        }
    };

   
    function getText(textId: string, defaultText: string): string {
        if(isLoading.value) {
            return defaultText; // Return default text while loading
        }
        const foundText = texts.value.find((text) => text.textId === textId);
        return foundText ? foundText.text : defaultText;
    }

    return {
        // Data
        texts,
        isLoading,
        fetchTexts,
        getText,
    };
});